import React, { useEffect, useState } from 'react'
import { useThemeContext } from "../../theme/ThemeContext"
import { LuSun, LuMoon, LuUser } from "react-icons/lu"

import { StorageGetItem, USER } from "../../lib/storage"
import logoMark from '../../assets/images/logo-mark.png'
import { logout } from "../../features/auth/logout"
import PropTypes from "prop-types"
import PopupWithActions from "../Popup/PopupWithAction"
import PortalBrandMark from "../PortalBrand/PortalBrandMark"
import { usePortalBrandContext } from "../PortalBrand/PortalBrandContext"
import { PORTAL_BRAND_STATUS } from "../PortalBrand/portalBrandStatus"

const Header = ({ children }) => {
  const { mode, toggleColorMode } = useThemeContext()
  const portalBrand = usePortalBrandContext()
  const [user, setUser] = useState({})
  const [anchor, setAnchor] = useState(null)
  const [open, setOpen] = useState(false)

  let role

  switch (user?.role) {
    case 'customer':
      role = 'CRM Admin'
      break
    case 'user':
      role = 'User'
      break
    case 'contact':
      role = 'Client Portal'
      break
    default:
      role = user?.role?.charAt(0).toUpperCase() + user?.role?.slice(1)
  }

  useEffect(() => {
    StorageGetItem(USER).then(result => {
      setUser(result)
    })
  }, [])

  const handleOpen = (event) => {
    setAnchor(event.currentTarget)
    setOpen(true)
  }

  const handleClose = () => {
    setAnchor(null)
    setOpen(false)
  }


  return (
    <div className="flex flex-row w-full justify-between items-center px-5 md:px-10 py-3">
      {portalBrand.status === PORTAL_BRAND_STATUS.LEGACY ? (
        <div className="flex items-center gap-2.5 mr-6 shrink-0">
          <img src={logoMark} alt="My Debt Lawyers" className="h-9 w-auto object-contain" />
          <div className="hidden sm:flex flex-col leading-none">
            <span className="text-[16px] font-extrabold tracking-tight text-text-primary">MY DEBT</span>
            <span className="text-[10px] font-semibold tracking-[0.2em] text-text-secondary mt-0.5">LAWYERS</span>
          </div>
        </div>
      ) : (
        <PortalBrandMark portalBrand={portalBrand} />
      )}
      {children ? <div>{children}</div> : ""}
      <div className="flex flex-row items-center">
        <button
          type="button"
          onClick={toggleColorMode}
          aria-label={mode === 'dark' ? 'Switch to light theme' : 'Switch to dark theme'}
          title={mode === 'dark' ? 'Light theme' : 'Dark theme'}
          className="mr-3 flex h-9 w-9 items-center justify-center rounded-full text-text-secondary bg-black/[0.04] hover:bg-black/[0.08] dark:bg-white/[0.06] dark:hover:bg-white/[0.12] hover:text-text-primary transition-colors"
        >
          {mode === 'dark' ? <LuSun size={18} /> : <LuMoon size={18} />}
        </button>
        {/* The placeholder was a fixed .jpg in a cool grey, which sat oddly against
            the warm neutral used elsewhere and could not follow the theme. Drawn
            instead, on a warm neutral in both modes. */}
        <button
          type="button"
          onClick={(event) => handleOpen(event)}
          aria-label="Account menu"
          className="cursor-pointer w-[40px] h-[40px] shrink-0 rounded-full md:mr-4 flex items-center justify-center bg-[#E7E5E4] text-[#57534E] transition-colors"
        >
          <LuUser size={20} />
        </button>
        <div className="hidden md:flex flex-col text-md">
          <span className="text-text-primary font-semibold">{user?.firstName} {user?.lastName}</span>
          <span className="text-text-secondary">{role}</span>
        </div>
        <PopupWithActions
          anchor={anchor}
          open={open}
          handleClose={handleClose}
        >
          <div onClick={logout}
            className="cursor-pointer p-[14px] rounded-md text-text-primary hover:bg-surface text-sm">
            Logout
          </div>
        </PopupWithActions>
      </div>
    </div>
  )
}

Header.propTypes = {
  children: PropTypes.string,
}
Header.defaultProps = {
  children: '',
}

export default Header
